<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="pa-0"
      >
        <v-list-item
          v-if="active"
          :disabled="!$store.getters.checkUserPrivilege('CORPORATE')"
          @click="inActivate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-lightbulb-off
            </v-icon>
            In-activate
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          :disabled="!$store.getters.checkUserPrivilege('CORPORATE')"
          @click="activate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-lightbulb-on
            </v-icon>
            Activate
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="fetchNotification()">
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-link-variant
            </v-icon>
            Create / Update Alert
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <edit-alert
      :show-dialog.sync="editAlert"
      :corporate-id="corporateId"
      @refresh="$emit('reload')"
    />
  </div>
</template>

<script>
import { failure } from "@/mixins/common";
import EditAlert from "@/components/account/EditAlert";

export default {
  name: "CorporateOptions",
  components: {
    EditAlert
  },
  mixins: [failure],
  props: {
    corporateId: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editAlert: false
    };
  },
  methods: {
    inActivate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to inactivate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/corporates/${this.corporateId}/inactivate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    activate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/corporates/${this.corporateId}/activate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    },
    fetchNotification(){
      this.editAlert = true;
    }
  }
};
</script>
